module.exports = __webpack_public_path__ + "img/icon_submenu7.cc3a9220.svg";